import { render, staticRenderFns } from "./EnvironmentCreate.vue?vue&type=template&id=03f86546&scoped=true&"
import script from "./EnvironmentCreate.vue?vue&type=script&lang=js&"
export * from "./EnvironmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f86546",
  null
  
)

export default component.exports